var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoStatsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.04176 16.5115H0C0.301538 19.5256 1.51372 22.2711 3.34179 24.4941L5.48271 22.3626C4.18912 20.7025 3.31767 18.6986 3.04176 16.5115Z",
    fill: "#01061B",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47363 26.6166C7.44268 28.2212 9.82181 29.344 12.4286 29.7973L12.6435 26.778C10.7784 26.4057 9.0657 25.6064 7.61681 24.4821L5.47363 26.6166Z",
    fill: "#01061B",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6505 26.9889L15.4357 30C17.5042 29.9414 19.4635 29.4513 21.2425 28.6423L19.7205 26.0447C18.4593 26.5806 17.0873 26.9108 15.6505 26.9889Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3198 24.5264L23.8448 27.13C25.0706 26.2429 26.1539 25.1719 27.063 23.9665L24.454 22.4099C23.8313 23.198 23.1189 23.9155 22.3198 24.5264Z",
    fill: "#01061B",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9582 13.5095H30C29.2401 5.93516 22.8038 0 15 0C7.1962 0 0.758368 5.93516 0 13.5095H3.04176C3.78807 7.59532 8.86069 3.0021 15 3.0021C21.1393 3.0021 26.2119 7.59532 26.9582 13.5095Z",
    fill: "#01061B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoStatsBlack);
export default __webpack_public_path__ + "static/media/no-stats-black.b9347ba2d14f48c3ddff776eb3ca0353.svg";
export { ForwardRef as ReactComponent };